(function (root, factory) {
  const api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.AOShirtCore = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  const MAX_PHOTO_BYTES = 10 * 1024 * 1024;
  const PHOTO_ACCEPT = ".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp";
  const PHOTO_TYPES = new Set(["image/jpeg", "image/png", "image/webp"]);
  const PHOTO_EXTENSIONS = new Set(["jpg", "jpeg", "png", "webp"]);

  function extension(name) {
    const match = String(name || "").toLowerCase().match(/\.([a-z0-9]+)$/);
    return match ? match[1] : "";
  }

  function validatePhotoFile(file) {
    if (!file) return "Vyber fotografiu vo formáte JPG, JPEG, PNG alebo WebP.";
    const suppliedType = String(file.type || "").toLowerCase();
    const validType = !suppliedType || PHOTO_TYPES.has(suppliedType);
    const validExtension = PHOTO_EXTENSIONS.has(extension(file.name));
    if (!validType || !validExtension) return "Nepodporovaný formát. Nahraj JPG, JPEG, PNG alebo WebP.";
    if (Number(file.size || 0) > MAX_PHOTO_BYTES) return "Fotografia je príliš veľká. Maximálna veľkosť je 10 MB.";
    return "";
  }

  function cropOutput(originalType) {
    const type = String(originalType || "").toLowerCase();
    if (type === "image/png") return { type: "image/png", extension: "png" };
    if (type === "image/webp") return { type: "image/webp", extension: "webp" };
    return { type: "image/jpeg", extension: "jpg" };
  }

  function normalizeOptionValue(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function displayOptionValue(value) {
    const normalized = normalizeOptionValue(value);
    if (normalized === "white" || normalized === "biela") return "Biela";
    if (normalized === "black" || normalized === "cierna") return "Čierna";
    if (normalized === "2xl" || normalized === "xxl") return "XXL";
    if (normalized === "3xl" || normalized === "xxxl") return "XXXL";
    return String(value || "");
  }

  function pricingLabel(preset, withPhoto) {
    const base = {
      front: "Iba predok",
      back: "Iba zadok",
      front_back: "Predok + zadok",
      all: "Predok + zadok + rukavy"
    }[preset] || "Iba predok";
    return withPhoto ? `${base} + foto` : base;
  }

  return Object.freeze({
    MAX_PHOTO_BYTES,
    PHOTO_ACCEPT,
    cropOutput,
    displayOptionValue,
    normalizeOptionValue,
    pricingLabel,
    validatePhotoFile
  });
});
